/* SessionContext.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._3YEZNO7dHp%7Bflex-shrink%3A1%7D%0A._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D%0A._00uqCY98eZ%7Btext-decoration-color%3AcurrentColor%7D%0A._3xtjKNYbGa%7Btext-decoration-line%3Anone%7D%0A._0H9qDF6wH8%7Btext-decoration-style%3Asolid%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._1pp6NdIZbP%7Bpointer-events%3Aauto%7D%0A._253ZDm98eZ%3Afocus-visible%7Btext-decoration-color%3AcurrentColor%7D%0A._2r76lK0Rl6%3Afocus-visible%7Btext-decoration-line%3Aunderline%7D%0A._4umoPx6wH8%3Afocus-visible%7Btext-decoration-style%3Asolid%7D%0A._253ZDmKGUX%3Afocus-visible%7Btext-decoration-color%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._0DCa9D98eZ%3Ahover%7Btext-decoration-color%3AcurrentColor%7D%0A._3932vv0Rl6%3Ahover%7Btext-decoration-line%3Aunderline%7D%0A._02cRtH6wH8%3Ahover%7Btext-decoration-style%3Asolid%7D%0A._0DCa9DKGUX%3Ahover%7Btext-decoration-color%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._4c065U1Y8M%7Bpadding-block%3Avar(--ds-space-050%2C4px)%7D%0A._1UtDYze5R3%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._1ANEUSzUZr%7Bwhite-space%3Anormal%7D%0A._3zvHkHdC7N%7Boverflow-wrap%3Aanywhere%7D%0A._253ZDme5R3%3Afocus-visible%7Btext-decoration-color%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0clgaMe5R3%3Ahover%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._0DCa9De5R3%3Ahover%7Btext-decoration-color%3Avar(--ds-text-inverse%2C%23fff)%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D");



































import React, { type ReactNode, useRef, useState } from 'react';
import { cx } from '@atlaskit/css';
import FileIcon from '@atlaskit/icon/core/file';
import ImageIcon from '@atlaskit/icon/core/image';
import LinkIcon from '@atlaskit/icon/core/link';
import PageIcon from '@atlaskit/icon/core/page';
import PagesIcon from '@atlaskit/icon/core/pages';
import StoryIcon from '@atlaskit/icon/core/story';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import Image from '@atlaskit/image/image';
import type { extractSmartLinkInlineIcon } from '@atlaskit/link-extractors/extract-smart-link-inline-icon';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import { isLinkableSessionContext } from './isLinkableSessionContext';
import { SessionContextOverflow } from './SessionContextOverflow';
import { useSessionContextMetadata } from './useSessionContextMetadata';
const styles = {
  context: "_3iDTPbccYA _0hPCNLDIqT _4ouGXIdnbC _1EqgXlN91d",
  primaryContext: "_3iDTPbvLZJ _4ouGXIdnbC _1EqgXlN91d",
  truncatedPrimaryContext: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC _1EqgXlN91d",
  contextLink: "_2mHwu81Y8M _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS _42Yu6B7dHp _4ouGXIdnbC _1EqgXlN91d _1UtDYzKGUX _1pp6NdIZbP _253ZDm98eZ _2r76lK0Rl6 _4umoPx6wH8 _253ZDmKGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0DCa9DKGUX",
  truncatedContextLabel: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
  popupLink: "_4c065U1Y8M _1UtDYze5R3 _1ANEUSzUZr _3zvHkHdC7N _253ZDme5R3 _0clgaMe5R3 _0DCa9De5R3",
  contextIcon: "_3iDTPbccYA _3YEZNOdnbC"
};
type ResolvedContext = {
  url: string;
  title?: string;
  icon?: ReturnType<typeof extractSmartLinkInlineIcon>;
};
export type SessionContextType = 'image' | 'file' | 'jira' | 'confluence' | 'link' | 'text';
export type SessionContextItem = Readonly<{
  id: string;
  label: string;
  type: SessionContextType;
  subtype?: 'space' | 'page' | 'whiteboard' | 'database' | 'slide';
  iconUrl?: string;
  url?: string;
}>;
type RawSessionContextProps = {
  /** Associated context items, in display priority order. */
  contexts: readonly SessionContextItem[];
  /** Opens file and image contexts in a caller-owned preview. */
  onFilePreview?: (fileUrl: string, fileName: string) => void;
  /** Whether the first context label may shrink within its metadata row. */
  truncate?: boolean;
  testId?: string;
};
type LegacySessionContextProps = {
  /** Compatibility for published consumers of pre-rendered context content. */
  context: ReactNode;
  contexts?: never;
  onFilePreview?: never;
  truncate?: never;
  testId?: string;
};
export type SessionContextProps = RawSessionContextProps | LegacySessionContextProps;

/** Reuses the http(s)-only convention from {@link isLinkableSessionContext}. */
const getValidIconUrl = (iconUrl: string | undefined): string | undefined => {
  const trimmed = iconUrl?.trim();
  if (!trimmed) {
    return undefined;
  }
  try {
    const url = new URL(trimmed);
    return url.protocol === 'https:' || url.protocol === 'http:' ? trimmed : undefined;
  } catch {
    return undefined;
  }
};

/** Restores the semantic icon mapping that predates ORS resolution, as the final fallback. */
const getSemanticContextIconComponent = (context: SessionContextItem): typeof PageIcon | null => {
  switch (context.type) {
    case 'image':
      return ImageIcon;
    case 'file':
      return FileIcon;
    case 'jira':
      return StoryIcon;
    case 'confluence':
      switch (context.subtype) {
        case 'space':
          return PagesIcon;
        case 'whiteboard':
          return WhiteboardIcon;
        case 'page':
        default:
          return PageIcon;
      }
    case 'link':
      return LinkIcon;
    case 'text':
      return null;
  }
};

/**
 * Renders the first usable icon in priority order: the ORS icon, then the session's own
 * `iconUrl`, then the semantic ADS icon for the context's type/subtype. A URL-rendered icon
 * that fails to load is tracked by value (not just a boolean) so it advances to the next
 * fallback without a stale failure suppressing a later, different, valid icon.
 */
const ContextIcon = ({
  icon,
  context,
  inverse = false
}: {
  icon: ResolvedContext['icon'];
  inverse?: boolean;
  context: SessionContextItem;
}) => {
  const [failedOrsIconUrl, setFailedOrsIconUrl] = useState<string>();
  const [failedSessionIconUrl, setFailedSessionIconUrl] = useState<string>();
  const orsIconUrl = (Array.isArray(icon) ? icon[0] : typeof icon === 'string' ? icon : undefined)?.trim();
  // An ORS icon that isn't a URL is an opaque React node (e.g. a rendered SVG); it is trusted
  // as-is because a load failure inside it cannot be observed from here.
  const orsIconNode = !orsIconUrl && icon ? icon : undefined;
  const sessionIconUrl = getValidIconUrl(context.iconUrl);
  let content: ReactNode;
  if (orsIconNode) {
    content = orsIconNode;
  } else if (orsIconUrl && orsIconUrl !== failedOrsIconUrl) {
    content = <Image src={orsIconUrl} alt="" width={16} height={16} onError={() => setFailedOrsIconUrl(orsIconUrl)} />;
  } else if (sessionIconUrl && sessionIconUrl !== failedSessionIconUrl) {
    content = <Image src={sessionIconUrl} alt="" width={16} height={16} onError={() => setFailedSessionIconUrl(sessionIconUrl)} />;
  } else {
    const SemanticIcon = getSemanticContextIconComponent(context);
    content = SemanticIcon ? <SemanticIcon label="" size="small" color={inverse ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)"} /> : null;
  }
  if (!content) {
    return null;
  }
  return <Box as="span" xcss={styles.contextIcon} aria-hidden="true">
			{content}
		</Box>;
};
const ContextLink = ({
  context,
  linkRef,
  metadata,
  onFilePreview,
  truncate = false,
  inverse = false,
  testId
}: {
  context: SessionContextItem & {
    url: string;
  };
  linkRef?: React.Ref<HTMLAnchorElement>;
  metadata?: ResolvedContext;
  onFilePreview?: (fileUrl: string, fileName: string) => void;
  truncate?: boolean;
  inverse?: boolean;
  testId?: string;
}) => {
  const url = context.url.trim();
  const title = metadata?.title?.trim() || context.label.trim();
  const opensFilePreview = onFilePreview != null && (context.type === 'file' || context.type === 'image');
  return <Anchor ref={linkRef} href={url} target="_blank" rel="noreferrer" onClick={opensFilePreview ? event => {
    event.preventDefault();
    onFilePreview?.(url, context.label.trim());
  } : undefined} xcss={cx(styles.contextLink, inverse && styles.popupLink)} testId={testId}>
			<ContextIcon key={url} icon={metadata?.icon} context={context} inverse={inverse} />
			<Box as="span" xcss={truncate ? styles.truncatedContextLabel : undefined}>
				<Text as="span" size="small" color={inverse ? 'color.text.inverse' : 'color.text.subtlest'}>
					{title}
				</Text>
			</Box>
		</Anchor>;
};
const StructuredSessionContext = ({
  contexts,
  onFilePreview,
  truncate = false,
  testId
}: RawSessionContextProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const primaryLinkRef = useRef<HTMLAnchorElement>(null);
  const eligibleContexts = contexts.filter(isLinkableSessionContext);
  const primaryContext = eligibleContexts[0];
  const hasOverflow = eligibleContexts.length > 1 && fg('rovo-chat-ai-inbox');
  const metadata = useSessionContextMetadata(eligibleContexts, isOpen && hasOverflow);
  if (!primaryContext) {
    return null;
  }
  return <Box as="span" xcss={styles.context} testId={testId}>
			<Box as="span" xcss={cx(styles.primaryContext, truncate && styles.truncatedPrimaryContext)} testId={testId ? `${testId}-primary` : undefined}>
				<ContextLink context={primaryContext} linkRef={primaryLinkRef} metadata={metadata.get(primaryContext.url.trim())} onFilePreview={onFilePreview} truncate={truncate} testId={testId ? `${testId}-label` : undefined} />
			</Box>
			{hasOverflow && <SessionContextOverflow fallbackFocusRef={primaryLinkRef} count={eligibleContexts.length - 1} isOpen={isOpen} onOpenChange={setIsOpen}>
					{eligibleContexts.map((context, index) => <Box as="li" key={`${context.id}-${index}`}>
							<ContextLink inverse context={context} metadata={metadata.get(context.url.trim())} onFilePreview={onFilePreview} />
						</Box>)}
				</SessionContextOverflow>}
		</Box>;
};

/** Renders linked context metadata and an ordered disclosure of all eligible contexts. */
export const SessionContext = (props: SessionContextProps): React.JSX.Element | null => {
  if ('context' in props) {
    if (props.context === undefined || props.context === null || props.context === false) {
      return null;
    }
    return <Box as="span" testId={props.testId}>
				{props.context}
			</Box>;
  }
  return <StructuredSessionContext {...props} />;
};